exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.control-label[data-v-03effc7e] {\n  font-weight: bold;\n  margin-bottom: 0;\n}\n", ""]);

// exports
